exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#received-files-header[data-v-36e7cf49]{min-height:75px;height:75px}#received-files-header h3[data-v-36e7cf49]{margin:0}.back-icon[data-v-36e7cf49]{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-36e7cf49","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/received-files-view/received-files-header.vue
// module id = 105
// module chunks = 0